import React, { useEffect, useState } from 'react';
import { Button, Icon, Tooltip } from 'antd';
import { connect } from 'react-redux';
import { compose } from 'redux';
import configs from 'configs';

import { requestSSE } from 'utils/request';

import injectReducer from 'utils/injectReducer';
import injectSaga from 'utils/injectSaga';

import reducer from './reducer-sidebar';
import saga from './saga-sidebar';

import { printQuotation } from './actions-sidebar';

import 'antComponentsStyle';

const SidebarButtons = ({ proposal, stillValid, printQuotation, currentStep }) => {
  const [updatedProposal, setProposal] = useState(proposal);

  let { quotation } = updatedProposal;
  quotation = quotation && quotation.data ? quotation.data : {};

  useEffect(
    () => {
      if (proposal && proposal.id && !proposal.has_pdf && currentStep >= configs.stepPDFdownloadable) {
        const eventSource = requestSSE(
          `${process.env.API_URL}proposals/sync/${proposal.id}`,
        );

        eventSource.addEventListener('update', response => {
          if (response && response.data) {
            const data = { ...updatedProposal, ...JSON.parse(response.data) };

            if (data.has_pdf) {
              setProposal(data);
              eventSource.close();
            }
          } else {
            console.error(response);
            eventSource.close();
          }
        });

        return () => {
          eventSource.close();
        };
      }

      setProposal(proposal);
    },
    [proposal, currentStep],
  );

  return (
      <>
        {updatedProposal.id && updatedProposal.has_pdf && (stillValid && currentStep >= configs.stepPDFdownloadable) ?
          <Button size="large" className="btn-print" onClick={() => printQuotation(updatedProposal.id)} block>
            Scarica <span className="d-xl-inline d-lg-none"> preventivo</span>
          </Button>
          :
          !updatedProposal.has_pdf && (stillValid && currentStep >= configs.stepPDFdownloadable) ?
            <Tooltip title="Il tuo preventivo potrà essere scaricato tra qualche istante...">
              <Button size="large" disabled block>
                Scarica <span className="d-xl-inline d-lg-none"> preventivo</span> <Icon type="loading" style={{color: "#1890ff", marginTop: '-5px'}} />
              </Button>
            </Tooltip>
            :
            <Tooltip title={`Completa lo step ${configs.stepPDFdownloadable} per poter scaricare la richiesta di preventivo!`}>
              <Button size="large" disabled block>
                Scarica <span className="d-xl-inline d-lg-none"> preventivo</span>
              </Button>
            </Tooltip>
        }
      </>
  );
};

export function mapDispatchToProps(dispatch) {
  return {
    printQuotation: quoteId => dispatch(printQuotation(quoteId)),
  };
}

const withReducer = injectReducer({ key: 'quotationSidebar', reducer });
const withSaga = injectSaga({ key: 'quotationSidebar', saga });

const withConnect = connect(
  null,
  mapDispatchToProps,
);

export default compose(
  withReducer,
  withSaga,
  withConnect,
)(SidebarButtons);
